<template>
  <div class="invitation-page">
    <div class="tableBox mt-8">
      <p v-if="loading" role="status">{{ $t('intake.portal.loading') }}</p>
      <div v-else-if="loadError" class="invitation-error" role="alert">
        <p>{{ loadError }}</p>
        <button class="invitation-retry" type="button" @click="loadInvitees">{{ $t('intake.bookingUi.retry') }}</button>
      </div>
      <v-data-table
          v-else
          disable-pagination
          hide-default-footer
          :items="users"
          :item-class="getItemClass"
          :headers="headers"
          :no-data-text="isFa ? 'هنوز دعوتی ثبت نشده است.' : 'No invitations have been recorded yet.'"
      >
        <template v-slot:item.id="{item}">
          {{ item.id }}
        </template>
        <template v-slot:item.payload="{item}">
          {{ item.payload?.source }}
          <br>
          {{ item.payload?.medium }}
        </template>
        <template v-slot:item.created_at="{item}">
          {{ item.created_at | dateFilter }}
        </template>
        <template v-slot:item.full_name="{item}">
          <template v-if="item.full_name == ' '">
            بدون نام
          </template>
          <template v-else>
            {{ item.full_name }}
          </template>
        </template>
        <template v-slot:item.first_purchase_date="{item}">
          <template v-if="item.first_purchase_date">
            {{ item.first_purchase_date | dateFilter }}
          </template>
          <template v-else class="">
            <v-btn color="grey" class="white--text font-weight-bold" x-small elevation="0">
              بدون خرید
            </v-btn>
          </template>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import momentJalali from "moment-jalaali";
/*eslint-disable*/
export default {
  data() {
    return {
      headers: [
        {text: 'ردیف', value: 'id', sortable: false, align: 'center'},
        {text: 'ایمیل', value: 'email', sortable: false, align: 'center'},
        {text: 'تاریخ اولین خرید', value: 'first_purchase_date', sortable: false, align: 'center'},
        {text: 'منبع', value: 'payload', sortable: false, align: 'center'},
        {text: 'تاریخ ثبت نام', value: 'created_at', sortable: false, align: 'center'},
      ],
      users: [],
      loading: false,
      loadError: '',
    }
  },
  computed: {
    isFa() { return (this.$route.params.lang || 'fa') === 'fa' },
  },
  mounted() {
    return this.loadInvitees()
  },
  methods: {
    loadInvitees() {
      if (this.loading) return Promise.resolve()
      this.loading = true
      this.loadError = ''
      this.$emitEvent('setLoading', true)
      return this.requesting('user', 'getInvitees').then((resp) => {
        if (!resp || (resp.type && !/^success$/i.test(resp.type)) || !Array.isArray(resp.data)) throw new Error('INVITATIONS_UNAVAILABLE')
        this.users = resp.data.map((item, i) => ({
          ...item, id: i + 1, payload: this.invitationPayload(item.payload),
        }))
      }).catch(() => {
        this.loadError = this.isFa
          ? 'فهرست دعوت‌ها دریافت نشد. دوباره تلاش کن.'
          : 'We could not load your invitations. Please try again.'
      }).finally(() => {
        this.loading = false
        this.$emitEvent('setLoading', false)
      })
    },
    invitationPayload(payload) {
      if (payload && typeof payload === 'object' && !Array.isArray(payload)) return payload
      try {
        const parsed = JSON.parse(payload)
        return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {}
      } catch (error) { return {} }
    },
    getItemClass(item) {
      if (item.first_purchase_date) {
        return 'withBuyRecord';
      }
    },
  },
  filters: {
    dateFilter(val) {
      if (!val) {
        return val;
      }
      return momentJalali(val).format('HH:mm jYYYY/jMM/jDD')
    }
  }
}
</script>

<style scoped>


.tableBox {
  padding: 10px;
  border-radius: 10px;
  width: 100%;
  max-width: 100%;
  margin: 0px auto;
  border: 1px solid var(--s-line-hairline, #f2efe8);
  background-color: var(--s-surface-card, white);
  overflow-x: auto;
}
.invitation-error { color: var(--s-ink-primary, #09364b); padding: 1rem; }
.invitation-retry { border-radius: var(--r-sm, .5rem); background: var(--s-action-primary, #16a49b); color: white; padding: .75rem 1rem; }
</style>
